import { api } from "@/lib/api";

// Buzón de avisos/tareas. Si hay parentToken (padres/alumno) se envía como header.
export async function fetchNotifications(parentToken) {
  const cfg = parentToken ? { headers: { "X-Parent-Token": parentToken } } : {};
  const { data } = await api.get("/notifications", cfg);
  return data;
}

export async function markNotificationsRead(parentToken) {
  const cfg = parentToken ? { headers: { "X-Parent-Token": parentToken } } : {};
  await api.post("/notifications/read", {}, cfg);
}

export function relativeTime(iso) {
  if (!iso) return "";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "hace un momento";
  const m = Math.floor(s / 60);
  if (m < 60) return `hace ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `hace ${d} d`;
  return new Date(iso).toLocaleDateString("es-MX", { day: "numeric", month: "short" });
}
